/**
 * Scroll lock hook for modals and overlays
 */
import { useEffect } from 'react';

/**
 * Hook for locking body scroll when a modal/overlay is open
 * @param isLocked - Whether scroll should be locked
 */
export const useScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const originalStyle = window.getComputedStyle(document.body).overflow;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isLocked) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.paddingRight = '';
    };
  }, [isLocked]);
};

export default useScrollLock;
